module.exports = __webpack_public_path__ + "img/factory-premises-view.jpg";